// extracted by mini-css-extract-plugin
export default {"suggestion":"Suggestion_suggestion__5WtK6","suggestionInfo":"Suggestion_suggestionInfo__fSuM0","button":"Suggestion_button__+5Z9y","image":"Suggestion_image__IDuZg"};